import React from 'react'

const rfInput = ({
  input,
  label,
  placeholder,
  disabled,
  type,
  required,
  style,
  onKeyPress,
  meta: { touched, error }
}) => {
  return (
  <div style={style}>
    {label && <h5>{label}</h5>}
    <input
      type={type || 'text'}
      disabled={disabled}
      placeholder={placeholder}
      required={required}
      className="form-control"
      onKeyPress={onKeyPress}
      {...input}
      style={style}
    /> 
    {touched && error && <span>{error}</span>}
  </div>
)}

export default rfInput



// WEBPACK FOOTER //
// ./src/lib/themes/lingk/rfInput.js